import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Gym = () => {

  return (
    <main id="main-content" className="min-h-screen bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Physical Education
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                P.S. 11X <span className="font-bold">Gym</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Building character through sports, health education, and SEL values that prepare our students for lifelong wellness and success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Program Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Our <span className="font-bold text-[#630503]">Mission</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Our physical education program is led by <span className="font-semibold text-gray-900">Mr. Salvatore</span> and <span className="font-semibold text-gray-900">Mr. Tsesmelis</span>. In addition to health education and sports instruction, the department looks to instill SEL values such as <span className="font-semibold text-[#630503]">hard work</span>, <span className="font-semibold text-[#630503]">determination</span>, and <span className="font-semibold text-[#630503]">perseverance</span>.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                At P.S. 11x, sports is not just an activity, but a <span className="font-semibold text-gray-900">way of life</span>. Our co-ed teams show our commitment to equity in sports and ensuring that <span className="font-semibold text-[#630503]">ALL students</span> have access to participating.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Teams */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Our <span className="font-bold text-[#630503]">Teams</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              P.S. 11x offers competitive sports teams that build teamwork, discipline, and school pride.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Soccer Team */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="bg-[#630503] p-6">
                <h3 className="text-2xl font-semibold text-white mb-2">Soccer Team</h3>
                <p className="text-white/90">Coach: Mr. Tsesmelis</p>
              </div>
              <div className="p-8">
                <p className="text-gray-600 leading-relaxed">
                  Our soccer team develops technical skills, teamwork, and sportsmanship while representing P.S. 11x with pride on the field.
                </p>
              </div>
            </div>

            {/* Basketball Team */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="bg-[#630503] p-6">
                <h3 className="text-2xl font-semibold text-white mb-2">Basketball Team</h3>
                <p className="text-white/90">Coach: Mr. Salvatore</p>
              </div>
              <div className="p-8">
                <p className="text-gray-600 leading-relaxed">
                  Our basketball team builds fundamental skills, strategic thinking, and team chemistry while competing with excellence and integrity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gym Facilities */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Our <span className="font-bold text-[#630503]">Facilities</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Take a look at our gymnasium facilities where students develop physical fitness and team skills.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Gym Facility */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">P.S. 11X Gymnasium</h3>
                <div className="bg-gray-200 rounded-lg h-80 flex items-center justify-center mb-6 overflow-hidden">
                  <img 
                    src="/assets/images/gym/gym.png" 
                    alt="P.S. 11x Gymnasium facility" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Our state-of-the-art gymnasium provides a safe and modern space for physical education classes, sports teams, and school-wide events.
                </p>
              </div>
            </div>

            {/* PE Program Activities */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Physical Education Activities</h3>
                <div className="bg-gray-200 rounded-lg h-80 flex items-center justify-center mb-6">
                  <div className="text-center text-gray-600">
                    <div className="text-6xl mb-4">🏃‍♂️</div>
                    <p className="text-lg font-medium">PE in Action</p>
                    <p className="text-sm">Students developing fitness and skills</p>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Students participate in a variety of physical activities that promote health, teamwork, and the development of motor skills across all grade levels.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#630503]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl lg:text-4xl font-light text-white mb-8">
              Join Our <span className="font-bold">PE Program</span>
            </h2>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-12">
              Every student can develop their physical fitness, character, and teamwork skills through our comprehensive PE program and sports teams.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-[#630503] hover:bg-white/90 font-semibold px-8 py-4 text-base transition-colors rounded-lg">
                Learn About Our Teams
              </button>
              <button className="bg-white/10 border border-white/30 text-white hover:bg-white/20 font-semibold px-8 py-4 text-base transition-colors rounded-lg">
                Contact PE Department
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
  };

export default Gym; 